import { Component, computed, inject, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { SharedModule } from '../../../../shared.module';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { UserCalendarService } from '../../../../../Reusables/reusable-pages/user-calendar/user-calendar.service';
import { Config } from '../../../../../configs/index.config';
import { ITextCase2 } from 'ets-fe-ng-sdk';
import { UserCalendarComponent } from '../../../../../Reusables/reusable-pages/user-calendar/user-calendar.component';
import { SaveUserCalendarNoteComponent } from '../../../../../Reusables/reusable-pages/user-calendar/save-user-calendar-note/save-user-calendar-note.component';
import { MatListModule } from '@angular/material/list';
import {
  ECalenderNoteType,
  ICalendarNote,
} from '../../../../../Reusables/reusable-pages/user-calendar/user-calendar.model';
import { ViewUserCalendarNoteComponent } from '../../../../../Reusables/reusable-pages/user-calendar/view-user-calendar-note/view-user-calendar-note.component';

import { Pipe, PipeTransform } from '@angular/core';
import { ModalComponent } from '../../../modal/modal.component';
import { UserCalendarHelperService } from '../../../../../Reusables/reusable-pages/user-calendar/user-calendar-helper.service';

@Pipe({ name: 'splitTime' })
export class splitTimePipe implements PipeTransform {
  transform(value: string) {
    return value.split(' ');
  }
}

@Component({
  selector: 'user-help-notes',
  imports: [
    SharedModule,
    UserCalendarComponent,
    SaveUserCalendarNoteComponent,
    MatListModule,
    ViewUserCalendarNoteComponent,
    splitTimePipe,
  ],
  templateUrl: './user-help-notes.component.html',
  styleUrl: './user-help-notes.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class UserHelpNotesComponent {
  readonly userCalendarHelperService = inject(UserCalendarHelperService);
  readonly loading = computed(() => this.service.currentDateNotesRes.isLoading());
  readonly notes = computed(() => {
    const eventTypeFilter = this.eventTypeFilter(),
      notes = this.service.currentNotes();
    return eventTypeFilter ? notes.filter((x) => x.eventType == eventTypeFilter) : notes;
  });
  readonly currentDate = computed(() => this.service.currentDate());
  readonly currentDateIsToday = computed(() => this.service.currentDateIsToday());

  readonly navigationChunks = computed(() =>
    [
      { date: this.service.yesterday() },
      { date: this.service.currentDate() },
      { date: this.service.tomorrow() },
    ].map((x) => ({ ...x, isToday: this.service.today() == x.date })),
  );

  readonly currentNote = signal<ICalendarNote>(null); 
  readonly eventTypeFilter = signal<ECalenderNoteType>(null);
  readonly showTodayBtn = computed(
    () =>
      Math.abs(new Date(this.currentDate()).getTime() - new Date(this.service.today()).getTime()) /
        Config.TimeStampDay >
      1,
  );
  readonly now = Date.now();
  readonly calendarModalRef = viewChild<ModalComponent>('calendarModal');

  constructor(public service: UserCalendarService) {}

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    // setTimeout(() => {
      
    //   this.calendarModalRef().open();
    // }, 1000);
  }

  refresh() {
    this.service.currentDateNotesRes.reload();
  }
}
